document.addEventListener("DOMContentLoaded", function () {
  // Create and inject CSS dynamically
  const style = document.createElement("style");
  style.textContent = `
        /* WPC Summary Override - Added via JS */
        body.woocommerce .wpc-configurator-wrap.style1 .wpc-summary,
        body.woocommerce .wpc-configurator-wrap.accordion .wpc-summary,
        body.woocommerce .wpc-configurator-wrap.accordion-2 .wpc-summary,
        .wpc-configurator-wrap.style1 .wpc-summary,
        .wpc-configurator-wrap.accordion .wpc-summary,
        .wpc-configurator-wrap.accordion-2 .wpc-summary,
        body.woocommerce .wpc-configurator-wrap.style3 .wpc-summary,
        .wpc-configurator-wrap.style3 .wpc-summary {
            width: unset !important;
            margin-bottom: unset !important;
            overflow: unset !important;
            float: unset !important;
        }
    `;

  // Add to head with high priority
  document.head.appendChild(style);
});

/**
 * Add Product Category to Cake builder
 */
document.addEventListener("DOMContentLoaded", function () {
  function insertBackToCategory() {
    const entrySummary = document.querySelector(".wpc-entry-summary");

    if (entrySummary) {
      // Check if we already added the back link
      if (entrySummary.querySelector(".back-to-category")) {
        return; // Already added
      }

      // Get the category info from PHP
      if (typeof wpcData !== "undefined" && wpcData.categoryLink) {
        const backLinkHTML = `
                    <div class="back-to-category">
                        <a href="${wpcData.categoryLink}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M19 12H5M12 19l-7-7 7-7"></path>
                            </svg>
                            BACK TO ${wpcData.categoryName.toUpperCase()}
                        </a>
                    </div>
                `;

        // Insert at the top of .wpc-entry-summary
        entrySummary.insertAdjacentHTML("afterbegin", backLinkHTML);
      }
    }
  }

  // Try multiple times as the plugin content might load dynamically
  setTimeout(insertBackToCategory, 500);

  // Watch for changes in case the plugin re-renders content
  const observer = new MutationObserver(function (mutations) {
    insertBackToCategory();
  });

  const configuratorEl =
    document.querySelector(".wpc-configurator-wrapper") || document.body;
  observer.observe(configuratorEl, { childList: true, subtree: true });
});

/**
 * Add Product Badges to Cake builder
 */
document.addEventListener("DOMContentLoaded", function () {
  function insertProductBadges() {
    const entrySummary = document.querySelector(".wpc-entry-summary");

    if (entrySummary) {
      // Check if we already added the badges
      if (entrySummary.querySelector(".arc-product-badge_badges-container")) {
        return; // Already added
      }

      // Get the badges info from PHP
      if (typeof wpcData !== "undefined" && wpcData.badgesHtml) {
        // Find the back-to-category element to insert badges after it
        const backToCategory = entrySummary.querySelector(".back-to-category");

        if (backToCategory) {
          // Insert badges after the back-to-category link
          backToCategory.insertAdjacentHTML("afterend", wpcData.badgesHtml);
        } else {
          // If no back-to-category link, insert at the top
          entrySummary.insertAdjacentHTML("afterbegin", wpcData.badgesHtml);
        }
      }
    }
  }

  // Try multiple times as the plugin content might load dynamically
  setTimeout(insertProductBadges, 600); // Slightly later than category

  // Watch for changes in case the plugin re-renders content
  const observer = new MutationObserver(function (mutations) {
    insertProductBadges();
  });

  const configuratorEl =
    document.querySelector(".wpc-configurator-wrapper") || document.body;
  observer.observe(configuratorEl, { childList: true, subtree: true });
});

/**
 * Add Product Title to Cake builder
 */
document.addEventListener("DOMContentLoaded", function () {
  function insertProductTitle() {
    const entrySummary = document.querySelector(".wpc-entry-summary");

    if (entrySummary) {
      // Check if we already added the title
      if (entrySummary.querySelector(".product_title")) {
        return; // Already added
      }

      // Get the title info from PHP
      if (typeof wpcData !== "undefined" && wpcData.titleHtml) {
        // Find the badges element to insert title after it
        const badges = entrySummary.querySelector(
          ".arc-product-badge_badges-container"
        );

        if (badges) {
          // Insert title after the badges
          badges.insertAdjacentHTML("afterend", wpcData.titleHtml);
        } else {
          // If no badges, look for back-to-category
          const backToCategory =
            entrySummary.querySelector(".back-to-category");
          if (backToCategory) {
            backToCategory.insertAdjacentHTML("afterend", wpcData.titleHtml);
          } else {
            // If nothing else, insert at the top
            entrySummary.insertAdjacentHTML("afterbegin", wpcData.titleHtml);
          }
        }
      }
    }
  }

  // Try multiple times as the plugin content might load dynamically
  setTimeout(insertProductTitle, 700); // After badges

  // Watch for changes in case the plugin re-renders content
  const observer = new MutationObserver(function (mutations) {
    insertProductTitle();
  });

  const configuratorEl =
    document.querySelector(".wpc-configurator-wrapper") || document.body;
  observer.observe(configuratorEl, { childList: true, subtree: true });
});

/**
 * Add Product Price to Cake builder
 */
document.addEventListener("DOMContentLoaded", function () {
  function insertProductPrice() {
    const entrySummary = document.querySelector(".wpc-entry-summary");

    if (entrySummary) {
      // Check if we already added the price
      if (entrySummary.querySelector(".price-stock-container")) {
        return; // Already added
      }

      // Get the price info from PHP
      if (typeof wpcData !== "undefined" && wpcData.priceHtml) {
        // Find the title element to insert price after it
        const productTitle = entrySummary.querySelector(".product_title");

        if (productTitle) {
          // Insert price after the title
          productTitle.insertAdjacentHTML("afterend", wpcData.priceHtml);
        } else {
          // If no title, look for badges
          const badges = entrySummary.querySelector(
            ".arc-product-badge_badges-container"
          );
          if (badges) {
            badges.insertAdjacentHTML("afterend", wpcData.priceHtml);
          } else {
            // If no badges, look for back-to-category
            const backToCategory =
              entrySummary.querySelector(".back-to-category");
            if (backToCategory) {
              backToCategory.insertAdjacentHTML("afterend", wpcData.priceHtml);
            } else {
              // If nothing else, insert at the top
              entrySummary.insertAdjacentHTML("afterbegin", wpcData.priceHtml);
            }
          }
        }
      }
    }
  }

  // Try multiple times as the plugin content might load dynamically
  setTimeout(insertProductPrice, 800); // After title

  // Watch for changes in case the plugin re-renders content
  const observer = new MutationObserver(function (mutations) {
    insertProductPrice();
  });

  const configuratorEl =
    document.querySelector(".wpc-configurator-wrapper") || document.body;
  observer.observe(configuratorEl, { childList: true, subtree: true });
});

/**
 * Add Cake Builder Information to Cake builder
 */
document.addEventListener("DOMContentLoaded", function () {
  function insertCakeBuilderInfo() {
    const entrySummary = document.querySelector(".wpc-entry-summary");

    if (entrySummary) {
      // Check if we already added the cake builder info
      if (entrySummary.querySelector(".cake-builder__information")) {
        return; // Already added
      }

      // Get the cake builder info from PHP
      if (typeof wpcData !== "undefined" && wpcData.cakeBuilderInfoHtml) {
        // Find the price element to insert info after it
        const priceContainer = entrySummary.querySelector(
          ".price-stock-container"
        );

        if (priceContainer) {
          // Insert info after the price
          priceContainer.insertAdjacentHTML(
            "afterend",
            wpcData.cakeBuilderInfoHtml
          );
        } else {
          // If no price, look for title
          const productTitle = entrySummary.querySelector(".product_title");
          if (productTitle) {
            productTitle.insertAdjacentHTML(
              "afterend",
              wpcData.cakeBuilderInfoHtml
            );
          } else {
            // If no title, look for badges
            const badges = entrySummary.querySelector(
              ".arc-product-badge_badges-container"
            );
            if (badges) {
              badges.insertAdjacentHTML(
                "afterend",
                wpcData.cakeBuilderInfoHtml
              );
            } else {
              // If no badges, look for back-to-category
              const backToCategory =
                entrySummary.querySelector(".back-to-category");
              if (backToCategory) {
                backToCategory.insertAdjacentHTML(
                  "afterend",
                  wpcData.cakeBuilderInfoHtml
                );
              } else {
                // If nothing else, insert at the top
                entrySummary.insertAdjacentHTML(
                  "afterbegin",
                  wpcData.cakeBuilderInfoHtml
                );
              }
            }
          }
        }
      }
    }
  }

  // Try multiple times as the plugin content might load dynamically
  setTimeout(insertCakeBuilderInfo, 900); // After price

  // Watch for changes in case the plugin re-renders content
  const observer = new MutationObserver(function (mutations) {
    insertCakeBuilderInfo();
  });

  const configuratorEl =
    document.querySelector(".wpc-configurator-wrapper") || document.body;
  observer.observe(configuratorEl, { childList: true, subtree: true });
});

/**
 * Add Product Description Accordion to Cake builder
 */
document.addEventListener("DOMContentLoaded", function () {
  function insertProductDescription() {
    const entrySummary = document.querySelector(".wpc-entry-summary");

    if (entrySummary) {
      // Check if we already added the description
      if (entrySummary.querySelector(".product-accordions-container")) {
        return; // Already added
      }

      // Get the description info from PHP
      if (typeof wpcData !== "undefined" && wpcData.descriptionHtml) {
        // Append at the very end of .wpc-entry-summary
        entrySummary.insertAdjacentHTML("beforeend", wpcData.descriptionHtml);
      }
    }
  }

  // Try multiple times as the plugin content might load dynamically
  setTimeout(insertProductDescription, 1000); // After all other content

  // Watch for changes in case the plugin re-renders content
  const observer = new MutationObserver(function (mutations) {
    insertProductDescription();
  });

  const configuratorEl =
    document.querySelector(".wpc-configurator-wrapper") || document.body;
  observer.observe(configuratorEl, { childList: true, subtree: true });
});

/**
 * Wrap all inserted content with proper div structure
 */
document.addEventListener("DOMContentLoaded", function () {
  function wrapInsertedContent() {
    const entrySummary = document.querySelector(".wpc-entry-summary");

    if (entrySummary) {
      // Check if we already wrapped the content
      if (entrySummary.querySelector(".product__detail-container")) {
        return; // Already wrapped
      }

      // Check if all our content has been inserted (excluding description which goes at the end)
      const hasBackToCategory = entrySummary.querySelector(".back-to-category");
      const hasCakeBuilderInfo = entrySummary.querySelector(
        ".cake-builder__information"
      );

      // Only wrap if we have at least the back to category (first element) and cake builder info (last element before description)
      if (hasBackToCategory && hasCakeBuilderInfo) {
        // Get all the elements that should be wrapped (excluding description)
        const elementsToWrap = [
          entrySummary.querySelector(".back-to-category"),
          entrySummary.querySelector(".arc-product-badge_badges-container"),
          entrySummary.querySelector(".product_title"),
          entrySummary.querySelector(".price-stock-container"),
          entrySummary.querySelector(".cake-builder__information"),
        ].filter((el) => el !== null); // Remove any null elements

        if (elementsToWrap.length > 0) {
          // Create the wrapper divs
          const productDetailContainer = document.createElement("div");
          productDetailContainer.className =
            "product__detail-container cake-builder__detail-container";

          const productInformation = document.createElement("div");
          productInformation.className = "product__information";

          // Move all elements into the inner wrapper
          elementsToWrap.forEach((element) => {
            productInformation.appendChild(element);
          });

          // Add the inner wrapper to the outer wrapper
          productDetailContainer.appendChild(productInformation);

          // Insert the wrapper structure at the beginning of entrySummary
          entrySummary.insertBefore(
            productDetailContainer,
            entrySummary.firstChild
          );
        }
      }
    }
  }

  // Run this after all other content has been inserted
  setTimeout(wrapInsertedContent, 1000); // After all content

  // Also watch for changes
  const observer = new MutationObserver(function (mutations) {
    // Delay the wrapping to ensure all elements are present
    setTimeout(wrapInsertedContent, 100);
  });

  const configuratorEl =
    document.querySelector(".wpc-configurator-wrapper") || document.body;
  observer.observe(configuratorEl, { childList: true, subtree: true });
});

// GLOBAL FUNCTION with individual nested UID mapping
function assignZIndexBasedOnUIDs() {
  // Step 1: Get the first occurrence of wpc-control-lists-inner
  const firstControlListsInner = document.querySelector(
    ".wpc-control-lists-inner"
  );

  if (!firstControlListsInner) {
    return;
  }

  // Step 2: Get all direct child <li> elements and their data-uid values
  const directChildLis = firstControlListsInner.querySelectorAll(":scope > li");
  const uids = [];

  directChildLis.forEach((li) => {
    const uid = li.getAttribute("data-uid");
    uids.push(uid);
  });

  // Step 3: Create a mapping where each UID (including nested ones) gets its own z-index
  const uidMapping = {};
  let currentZIndex = 1;

  uids.forEach((topLevelUid) => {
    // Find the top-level control item
    const topLevelItem = document.querySelector(
      `[data-uid="${topLevelUid}"].wpc-control-has-children`
    );

    if (topLevelItem) {
      // Find all nested sub-groups within this top-level item
      const nestedSubGroups = topLevelItem.querySelectorAll(
        ".wpc-control-has-children[data-uid]"
      );

      // Check if this top-level item has nested sub-groups
      const actualNestedSubGroups = Array.from(nestedSubGroups).filter(
        (subGroup) => {
          const subGroupUid = subGroup.getAttribute("data-uid");
          return subGroupUid && subGroupUid !== topLevelUid;
        }
      );

      if (actualNestedSubGroups.length > 0) {
        // This top-level UID has nested sub-groups, assign z-index to each sub-group
        actualNestedSubGroups.forEach((subGroup) => {
          const subGroupUid = subGroup.getAttribute("data-uid");
          uidMapping[subGroupUid] = currentZIndex;
          currentZIndex++;
        });
      } else {
        // This top-level UID has no nested sub-groups, assign z-index directly
        uidMapping[topLevelUid] = currentZIndex;
        currentZIndex++;
      }
    }
  });

  // Step 4: Get all elements that have data-parent-uid and assign z-index
  const imageLayerElements = document.querySelectorAll("[data-parent-uid]");

  imageLayerElements.forEach((element) => {
    const parentUid = element.getAttribute("data-parent-uid");

    if (uidMapping.hasOwnProperty(parentUid)) {
      const zIndex = uidMapping[parentUid];
      element.style.zIndex = zIndex;
    }
  });
}

// Run the function on DOM content loaded
document.addEventListener("DOMContentLoaded", function () {
  // Run z-index assignment on DOM ready
  assignZIndexBasedOnUIDs();

  // Start watching for new elements
  const configuratorEl =
    document.querySelector(".wpc-carousel-stage") ||
    document.querySelector(".wpc-configurator-wrapper") ||
    document.body;

  newElementObserver.observe(configuratorEl, {
    childList: true,
    subtree: true,
  });
});

// Single event listener that handles all interactions
document.addEventListener(
  "click",
  (e) => {
    const anyControlItem = e.target.closest(".wpc-control-item");
    if (anyControlItem) {
      // Run immediately for existing elements
      assignZIndexBasedOnUIDs();
    }
  },
  true
); // Event capture phase

// Watch for new elements being added and apply z-index instantly
const newElementObserver = new MutationObserver((mutations) => {
  let hasNewElements = false;

  mutations.forEach((mutation) => {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach((node) => {
        // Check if the new node has data-parent-uid or contains elements with it
        if (node.nodeType === 1) {
          if (node.hasAttribute && node.hasAttribute("data-parent-uid")) {
            hasNewElements = true;
          } else if (
            node.querySelector &&
            node.querySelector("[data-parent-uid]")
          ) {
            hasNewElements = true;
          }
        }
      });
    }
  });

  if (hasNewElements) {
    // Apply z-index immediately when new elements are detected
    assignZIndexBasedOnUIDs();
  }
});

// Manual trigger function you can call from console for testing
window.manualZIndexAssignment = function () {
  assignZIndexBasedOnUIDs();
};

const WPCIconManager = {
  iconWrap: null,
  controlItems: [],
  customIcons: [],
  observer: null,
  resizeObserver: null,

  init() {
    this.cleanupAndSetupIconWrap();
    this.setupObservers();
    this.updateIcons();

    // Add a delayed check to catch any items that get current class added after page load
    setTimeout(() => {
      this.updateAllStepCompleteStates();
    }, 2000);

    // Also check after a longer delay to catch any slow-loading content
    setTimeout(() => {
      this.updateAllStepCompleteStates();
    }, 5000);
  },

  cleanupAndSetupIconWrap() {
    // Find the parent wrap
    const parentWrap = document.querySelector(".wpc-controls-parent-wrap");
    if (!parentWrap) {
      return false;
    }

    // Remove all existing wpc-custom-icon-wrap elements
    const existingIconWraps = parentWrap.querySelectorAll(
      ".wpc-custom-icon-wrap"
    );
    existingIconWraps.forEach((wrap) => {
      wrap.remove();
    });

    // Create the new icon wrap
    this.iconWrap = document.createElement("div");
    this.iconWrap.className = "wpc-custom-icon-wrap";

    // Find the controls wrap to insert before it
    const controlsWrap = parentWrap.querySelector(".wpc-controls-wrap");
    if (controlsWrap) {
      // Insert the icon wrap BEFORE the controls wrap
      parentWrap.insertBefore(this.iconWrap, controlsWrap);
    } else {
      // Fallback: just add it at the beginning
      parentWrap.insertBefore(this.iconWrap, parentWrap.firstChild);
    }

    return true;
  },

  getTopLevelControlItems() {
    // Get all wpc-control-has-children elements
    const allControlItems = Array.from(
      document.querySelectorAll(".wpc-control-item.wpc-control-has-children")
    );

    // Filter out nested ones - only keep items that don't have another wpc-control-has-children as an ancestor
    const topLevelItems = allControlItems.filter((item) => {
      // Check if this item has any wpc-control-has-children ancestors
      let parent = item.parentElement;
      while (parent && !parent.classList.contains("wpc-controls-parent-wrap")) {
        if (
          parent.classList &&
          parent.classList.contains("wpc-control-has-children")
        ) {
          return false; // This item is nested inside another wpc-control-has-children
        }
        parent = parent.parentElement;
      }
      return true; // This is a top-level item
    });

    return topLevelItems;
  },

  updateIcons() {
    if (!this.iconWrap) {
      return;
    }

    // Get only top-level control items (not nested ones)
    this.controlItems = this.getTopLevelControlItems();

    // Clear existing icons completely
    this.customIcons = [];
    this.iconWrap.innerHTML = ""; // Clear all existing content

    if (this.controlItems.length === 0) {
      this.iconWrap.innerHTML =
        '<p class="wpc-no-items">No top-level control items with children found</p>';
      return;
    }

    // Create new icons for each control item
    this.controlItems.forEach((controlItem, index) => {
      const customIcon = this.createCustomIcon(controlItem, index);
      this.iconWrap.appendChild(customIcon);
      this.customIcons.push(customIcon);
    });

    // Setup resize observers for height changes
    this.setupResizeObservers();

    // Update active states for all icons
    this.updateAllActiveStates();

    // Update step complete states for all icons
    this.updateAllStepCompleteStates();
  },

  createCustomIcon(controlItem, index) {
    const customIcon = document.createElement("div");
    customIcon.className = "wpc-custom-icon";
    customIcon.dataset.index = index;
    customIcon.dataset.associatedWith = `wpc-control-has-children-${index}`;

    // Get initial height and width
    const height = this.getElementHeight(controlItem);
    const width = this.getElementWidth(controlItem);

    // Create circle icon wrapper and icon
    const circleIconWrapper = document.createElement("div");
    circleIconWrapper.className = "circle-icon-wrapper";

    const circleIcon = document.createElement("div");
    circleIcon.className = "circle-icon";

    const circleBeforeLine = document.createElement("div");
    circleBeforeLine.className = "circle-before-line";

    const circleAfterLine = document.createElement("div");
    circleAfterLine.className = "circle-after-line";

    circleIconWrapper.appendChild(circleIcon);
    circleIconWrapper.appendChild(circleAfterLine);

    // Create height display paragraph
    const heightDisplay = document.createElement("p");
    heightDisplay.className = "wpc-height-display";
    heightDisplay.textContent = `Item ${index + 1}: ${height}px`;

    // Set dynamic dimensions
    customIcon.style.height = `${height}px`;
    customIcon.style.maxWidth = `${width}px`;

    // Append circle icon wrapper first, then height display
    customIcon.appendChild(circleIconWrapper);
    customIcon.appendChild(heightDisplay);

    return customIcon;
  },

  getElementHeight(element) {
    const rect = element.getBoundingClientRect();
    const height = Math.round(rect.height) + 20;
    return height;
  },

  getElementWidth(element) {
    const rect = element.getBoundingClientRect();
    const width = Math.round(rect.width);
    return width;
  },

  updateIconSize(controlItem, customIcon) {
    const height = this.getElementHeight(controlItem);
    const width = this.getElementWidth(controlItem);
    const index = customIcon.dataset.index;

    // Update icon size
    customIcon.style.height = `${height}px`;
    customIcon.style.maxWidth = `${width}px`;

    // Update height display
    const heightDisplay = customIcon.querySelector(".wpc-height-display");
    if (heightDisplay) {
      heightDisplay.textContent = `Item ${parseInt(index) + 1}: ${height}px`;
    }
  },

  // Method to update active state for a specific icon
  updateActiveState(controlItem, customIcon) {
    const circleIconWrapper = customIcon.querySelector(".circle-icon-wrapper");
    if (!circleIconWrapper) {
      return;
    }

    const isActive = controlItem.classList.contains("wpc-group-active");

    if (isActive) {
      circleIconWrapper.classList.add("active");
    } else {
      circleIconWrapper.classList.remove("active");
    }
  },

  // Updated method to handle ANY nested wpc-control-lists-inner elements
  updateStepCompleteState(controlItem, customIcon) {
    const circleIconWrapper = customIcon.querySelector(".circle-icon-wrapper");
    if (!circleIconWrapper) {
      return;
    }

    // Find ALL sub-groups within this control item (not just "Tier" ones)
    const subGroups = controlItem.querySelectorAll(
      "li.wpc-control-item.wpc-control-has-children"
    );

    // Filter out any that are also top-level items (to avoid counting nested top-level items)
    const topLevelItems = this.getTopLevelControlItems();
    const actualSubGroups = Array.from(subGroups).filter(
      (subGroup) => !topLevelItems.includes(subGroup)
    );

    let allHaveCurrent = true;

    if (actualSubGroups.length === 0) {
      // No sub-groups found, check direct wpc-control-lists-inner for current items
      const directControlListsInner = controlItem.querySelector(
        ".wpc-control-lists-inner"
      );

      if (!directControlListsInner) {
        allHaveCurrent = false;
      } else {
        const currentItems = directControlListsInner.querySelectorAll(
          ".wpc-control-item.current"
        );
        const hasCurrentChild = currentItems.length > 0;

        if (!hasCurrentChild) {
          allHaveCurrent = false;
        }
      }
    } else {
      // Check each sub-group for current items in their wpc-control-lists-inner
      actualSubGroups.forEach((subGroup, index) => {
        // Find the wpc-control-lists-inner within this sub-group
        const subGroupControlListsInner = subGroup.querySelector(
          ".wpc-control-lists-inner"
        );
        let subGroupHasCurrent = false;

        if (subGroupControlListsInner) {
          // Use a broad selector to find current items anywhere within the sub-group's list
          const currentItems = subGroupControlListsInner.querySelectorAll(
            ".wpc-control-item.current"
          );
          subGroupHasCurrent = currentItems.length > 0;
        }

        if (!subGroupHasCurrent) {
          allHaveCurrent = false;
        }
      });
    }

    if (allHaveCurrent) {
      circleIconWrapper.classList.add("step-complete");
    } else {
      circleIconWrapper.classList.remove("step-complete");
    }
  },

  // Method to update all active states
  updateAllActiveStates() {
    this.controlItems.forEach((controlItem, index) => {
      if (this.customIcons[index]) {
        this.updateActiveState(controlItem, this.customIcons[index]);
      }
    });
  },

  // Method to update all step complete states
  updateAllStepCompleteStates() {
    this.controlItems.forEach((controlItem, index) => {
      if (this.customIcons[index]) {
        this.updateStepCompleteState(controlItem, this.customIcons[index]);
      }
    });
  },

  setupResizeObservers() {
    // Clean up existing observers
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.controlItems.length === 0) return;

    // Create ResizeObserver with throttling for better performance
    let resizeTimeout = null;

    this.resizeObserver = new ResizeObserver((entries) => {
      // Throttle resize updates to avoid excessive calls
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        entries.forEach((entry) => {
          const controlItem = entry.target;
          const index = this.controlItems.indexOf(controlItem);

          if (index !== -1 && this.customIcons[index]) {
            this.updateIconSize(controlItem, this.customIcons[index]);
          }
        });
      }, 10);
    });

    // Observe all control items with children
    this.controlItems.forEach((item, index) => {
      this.resizeObserver.observe(item);
    });
  },

  setupObservers() {
    // Clean up existing observer
    if (this.observer) {
      this.observer.disconnect();
    }

    // Debounce variables
    let updateTimeout = null;
    let activeStateTimeout = null;

    // Create NEW mutation observer to watch for changes
    this.observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      let activeStateChanges = new Set();
      let stepCompleteChanges = new Set();

      mutations.forEach((mutation) => {
        // Only watch for new control items being added
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if (
                node.classList?.contains("wpc-control-has-children") ||
                node.querySelector?.(".wpc-control-has-children")
              ) {
                shouldUpdate = true;
              }
            }
          });
        }

        // Watch for class changes that affect wpc-group-active or current
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const target = mutation.target;
          const oldClasses = mutation.oldValue || "";
          const currentClasses = target.classList.toString();

          // Check for wpc-group-active changes on top-level items
          if (target.classList?.contains("wpc-control-has-children")) {
            const hadActive = oldClasses.includes("wpc-group-active");
            const hasActive = target.classList.contains("wpc-group-active");

            if (hadActive !== hasActive) {
              // Make sure this is a top-level item
              const topLevelItems = this.getTopLevelControlItems();
              if (topLevelItems.includes(target)) {
                activeStateChanges.add(target);
              }
            }
          }

          // Check for current class changes on any wpc-control-item
          if (target.classList?.contains("wpc-control-item")) {
            const hadCurrent = oldClasses.includes("current");
            const hasCurrent = target.classList.contains("current");

            if (hadCurrent !== hasCurrent) {
              // Find the correct top-level parent control item using the working containment logic
              const topLevelItems = this.getTopLevelControlItems();

              // Use the SAME logic that works in inspectCurrent()
              let parentControlItem = null;
              for (const topLevelItem of topLevelItems) {
                if (topLevelItem.contains(target)) {
                  parentControlItem = topLevelItem;
                  break;
                }
              }

              if (parentControlItem) {
                stepCompleteChanges.add(parentControlItem);
              }
            }
          }
        }
      });

      // Handle active state changes
      if (activeStateChanges.size > 0) {
        clearTimeout(activeStateTimeout);
        activeStateTimeout = setTimeout(() => {
          activeStateChanges.forEach((target) => {
            const index = this.controlItems.indexOf(target);
            if (index !== -1 && this.customIcons[index]) {
              this.updateActiveState(target, this.customIcons[index]);
            }
          });
        }, 50);
      }

      // Handle step complete changes
      if (stepCompleteChanges.size > 0) {
        clearTimeout(activeStateTimeout);
        activeStateTimeout = setTimeout(() => {
          stepCompleteChanges.forEach((target) => {
            const index = this.controlItems.indexOf(target);
            if (index !== -1 && this.customIcons[index]) {
              this.updateStepCompleteState(target, this.customIcons[index]);
            }
          });
        }, 100);
      }

      // Handle full updates (only when new items are added)
      if (shouldUpdate) {
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(() => this.updateIcons(), 1000);
      }
    });

    // Start observing with minimal scope and track old values for class changes
    const configuratorEl =
      document.querySelector(".wpc-configurator-wrapper") ||
      document.querySelector(".wpc-controls-parent-wrap") ||
      document.body;

    this.observer.observe(configuratorEl, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"], // Only watch class changes
      attributeOldValue: true, // Track old values to detect actual changes
    });
  },

  // Manual refresh method
  refresh() {
    this.updateIcons();
  },

  // Get info about current state
  getInfo() {
    return {
      iconWrapFound: !!this.iconWrap,
      iconWrapLocation: this.iconWrap
        ? "properly positioned in parent wrap"
        : "not found",
      controlItems: this.controlItems.length,
      customIcons: this.customIcons.length,
      heights: this.controlItems.map((item) => this.getElementHeight(item)),
      controlElements: this.controlItems,
      activeStates: this.controlItems.map((item) =>
        item.classList.contains("wpc-group-active")
      ),
      stepCompleteStates: this.controlItems.map((item) => {
        const subGroups = item.querySelectorAll(
          "li.wpc-control-item.wpc-control-has-children"
        );
        const topLevelItems = this.getTopLevelControlItems();
        const actualSubGroups = Array.from(subGroups).filter(
          (subGroup) => !topLevelItems.includes(subGroup)
        );
        let allHaveCurrent = true;

        if (actualSubGroups.length === 0) {
          const directControlListsInner = item.querySelector(
            ".wpc-control-lists-inner"
          );
          if (!directControlListsInner) {
            allHaveCurrent = false;
          } else {
            const currentItems = directControlListsInner.querySelectorAll(
              ".wpc-control-item.current"
            );
            if (currentItems.length === 0) {
              allHaveCurrent = false;
            }
          }
        } else {
          actualSubGroups.forEach((subGroup) => {
            const subGroupControlListsInner = subGroup.querySelector(
              ".wpc-control-lists-inner"
            );
            let subGroupHasCurrent = false;

            if (subGroupControlListsInner) {
              const currentItems = subGroupControlListsInner.querySelectorAll(
                ".wpc-control-item.current"
              );
              subGroupHasCurrent = currentItems.length > 0;
            }

            if (!subGroupHasCurrent) {
              allHaveCurrent = false;
            }
          });
        }

        return allHaveCurrent;
      }),
    };
  },
};

// Initialize with additional timing checks
const initManager = () => {
  WPCIconManager.init();

  // Also listen for common events that might indicate content is ready
  if (window.jQuery) {
    window.jQuery(document).ready(() => {
      setTimeout(() => {
        WPCIconManager.updateAllStepCompleteStates();
      }, 1000);
    });

    window.jQuery(window).on("load", () => {
      setTimeout(() => {
        WPCIconManager.updateAllStepCompleteStates();
      }, 1000);
    });
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initManager);
} else {
  initManager();
}


// Listen for clicks on the control items using capture phase to bypass Alpine.js click.stop
document.addEventListener('click', (e) => {
    // Check if click is on the layer title wrapper (parent header area)
    const clickedTitle = e.target.closest('.wpc-layer-title-wrap');
    
    if (clickedTitle) {
        // Find the IMMEDIATE parent control item that owns this title (not ancestors)
        const clickedItem = clickedTitle.parentElement.closest('.wpc-control-item.wpc-control-has-children');
        
        if (clickedItem) {
            // Check if this is a TOP-LEVEL item (not nested)
            const topLevelItems = WPCIconManager.getTopLevelControlItems();
            
            // Check if the clicked item is DIRECTLY in the top level array
            const index = topLevelItems.indexOf(clickedItem);
            
            // Additional check: Make sure the title's parent item IS the same as what we found
            const titleParent = clickedTitle.parentElement;
            const isDirectParent = titleParent === clickedItem;
            
            // ONLY proceed if this is actually in the top level items array AND is direct parent
            if (index !== -1 && isDirectParent && WPCIconManager.customIcons[index]) {
                // Update both active state and step complete state for the clicked item
                setTimeout(() => {
                    WPCIconManager.updateActiveState(clickedItem, WPCIconManager.customIcons[index]);
                    WPCIconManager.updateStepCompleteState(clickedItem, WPCIconManager.customIcons[index]);
                }, 150);
                
                // Scroll to position the TOP of the element in the center of the screen
                setTimeout(() => {
                    const rect = clickedItem.getBoundingClientRect();
                    const absoluteTop = window.pageYOffset + rect.top;
                    const middle = absoluteTop - (window.innerHeight / 2);
                    
                    window.scrollTo({
                        top: middle,
                        behavior: 'smooth'
                    });
                }, 200);
            }
        }
    }
    
    // Handle child item clicks (for step complete state updates only)
    const clickedChild = e.target.closest('.wpc-control-item');
    if (clickedChild && !clickedChild.classList.contains('wpc-control-has-children') && 
        (clickedChild.classList.contains('current') || clickedChild.classList.contains('image-loaded'))) {
        // Find the top-level parent control item using contains method
        const topLevelItems = WPCIconManager.getTopLevelControlItems();
        let parentControlItem = null;
        
        for (const topLevelItem of topLevelItems) {
            if (topLevelItem.contains(clickedChild)) {
                parentControlItem = topLevelItem;
                break;
            }
        }
        
        if (parentControlItem) {
            const index = topLevelItems.indexOf(parentControlItem);
            
            if (index !== -1 && WPCIconManager.customIcons[index]) {
                // Update step complete state for the correct parent item
                setTimeout(() => {
                    WPCIconManager.updateStepCompleteState(parentControlItem, WPCIconManager.customIcons[index]);
                }, 150);
            }
        }
    }
}, true); // TRUE = capture phase, runs BEFORE Alpine.js handlers

// Make it globally accessible
window.WPCIconManager = WPCIconManager;

/**
 * Loading Animation Manager - Shows on page load, hides when 100% complete
 */
const LoadingAnimationManager = {
  overlay: null,
  completionChecks: [],
  checkInterval: null,

  init() {
    this.createLoadingOverlay();
    this.setupCompletionChecks();
    this.startChecking();
  },

  showConfiguratorWrap() {
    // Show the configurator wrap when loading is complete
    const configuratorWrap = document.querySelector(
      ".product-configurator-wrapper"
    );
    if (configuratorWrap) {
      configuratorWrap.classList.add("loading-complete");
    }
  },

  createLoadingOverlay() {
    const container = document.querySelector(".product-with-configurator");
    if (!container) {
      console.warn("Product with configurator container not found");
      return;
    }

    // Create overlay
    this.overlay = document.createElement("div");
    this.overlay.className = "product-configurator-loading-overlay";
    this.overlay.innerHTML = `
            <div class="product-configurator-loading-spinner">
                <div class="spinner"></div>
                <div class="loading-text">Loading cake builder...</div>
            </div>
        `;

    container.appendChild(this.overlay);
  },

  setupCompletionChecks() {
    this.completionChecks = [
      () => document.querySelector(".wpc-entry-summary .back-to-category"),
      () =>
        document.querySelector(
          ".wpc-entry-summary .arc-product-badge_badges-container"
        ),
      () => document.querySelector(".wpc-entry-summary .product_title"),
      () => document.querySelector(".wpc-entry-summary .price-stock-container"),
      () =>
        document.querySelector(".wpc-entry-summary .cake-builder__information"),
      () =>
        document.querySelector(".wpc-entry-summary .product__detail-container"),
      () => {
        // Check if description exists in wpcData, and if so, check if it's rendered
        if (typeof wpcData !== "undefined" && wpcData.descriptionHtml) {
          return document.querySelector(
            ".wpc-entry-summary .product-accordions-container"
          );
        }
        return true; // If no description data, consider this check as passed
      },
      () =>
        window.WPCIconManager &&
        window.WPCIconManager.iconWrap &&
        window.WPCIconManager.customIcons.length > 0,
    ];
  },

  startChecking() {
    this.checkInterval = setInterval(() => {
      if (this.isComplete()) {
        this.hideLoading();
      }
    }, 100);
  },

  isComplete() {
    // ALL checks must pass for 100% completion
    return this.completionChecks.every((check) => {
      try {
        return check();
      } catch (e) {
        return false;
      }
    });
  },

  hideLoading() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }

    if (this.overlay) {
      // Show the configurator wrap
      this.showConfiguratorWrap();

      // Remove the loading overlay
      setTimeout(() => {
        if (this.overlay && this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
        }
        this.overlay = null;
      }, 300);
    }
  },
};

// Initialize immediately - will show on page load
LoadingAnimationManager.init();

/**
 * Simple Layer Group Opacity Manager
 * Adds 'has-selected-item' class to wpc-layer-type-group when items are selected
 */
document.addEventListener("DOMContentLoaded", function () {
  function updateLayerGroupOpacity() {
    const layerGroups = document.querySelectorAll(".wpc-layer-type-group");

    layerGroups.forEach((group) => {
      const hasSelectedItem =
        group.querySelector(".wpc-control-item.current") !== null;

      if (hasSelectedItem) {
        group.classList.add("has-selected-item");
      } else {
        group.classList.remove("has-selected-item");
      }
    });
  }

  // Update on page load
  updateLayerGroupOpacity();

  // Update when control items are clicked
  document.addEventListener("click", function (e) {
    if (e.target.closest(".wpc-control-item")) {
      setTimeout(updateLayerGroupOpacity, 100);
    }
  });

  // Watch for class changes
  const observer = new MutationObserver(function (mutations) {
    let shouldUpdate = false;
    mutations.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class" &&
        mutation.target.classList.contains("wpc-control-item")
      ) {
        shouldUpdate = true;
      }
    });

    if (shouldUpdate) {
      setTimeout(updateLayerGroupOpacity, 50);
    }
  });

  const configurator =
    document.querySelector(".wpc-configurator-wrapper") || document.body;
  observer.observe(configurator, {
    attributes: true,
    attributeFilter: ["class"],
    subtree: true,
  });
});
